export const PERMISSION_ROLES = {
  CREATE: 'RoleModule.create',
  VIEW: 'RoleModule.view',
  UPDATE: 'RoleModule.update',
  DELETE: 'RoleModule.delete',
};
